import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "./App.css";
// import App from './App';
import reportWebVitals from './reportWebVitals';
// import { createRoot } from "react-dom/client";
import App from './App';

// const root = createRoot(document.getElementById('root'));
ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
document.getElementById('root'));
// window.location.replace("https://www.richhosek.com/#podcast");

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
